import { jsx as _jsx } from "react/jsx-runtime";
import { LockOpenOutlined, LockOutlined } from "sprout-ui-icons";
import { useCallback } from "react";
import { MenuItem } from "@sprout/list-navigation/dist/Menu";
import { usePostPage } from "../../PostPageContext";
import { usePostPageViewMode } from "../../PostPageViewModeContext";
const PostPageToolbarMenuViewMode = ()=>{
    const { disabled  } = usePostPage();
    const [mode, setMode] = usePostPageViewMode();
    const isEdit = mode === "EDIT";
    const handleClick = useCallback(()=>{
        setMode(isEdit ? "VIEW" : "EDIT");
    }, [
        isEdit,
        setMode
    ]);
    if (disabled) return null;
    return /*#__PURE__*/ _jsx(MenuItem, {
        label: isEdit ? "Lock page" : "Unlock page",
        icon: isEdit ? LockOutlined : LockOpenOutlined,
        onClick: handleClick
    });
};
export default PostPageToolbarMenuViewMode;
